// extracted by mini-css-extract-plugin
module.exports = {"twoColumn__content":"TwoColumn--twoColumn__content--23w-T","offset":"TwoColumn--offset--1CGZs","twoColumn__lead":"TwoColumn--twoColumn__lead--mC_8s"};